export const TN_GOVERNANTES = [
    "",
    "Ariana",
    "Beja",
    "Ben Arous",
    "Bizerte",
    "Gabes",
    "Gafsa",
    "Jendouba",
    "Kairouan",
    "Kasserine",
    "Kebili",
    "Kef",
    "Mahdia",
    "Mannouba",
    "Medenine",
    "Monastir",
    "Nabeul",
    "Sfax",
    "Sidi Bouzid",
    "Siliana",
    "Sousse",
    "Tataouine",
    "Tozeur",
    "Tunis",
    "Zaghouan",
];

export const LIBYA_GOVERNANTES = [
    "",
    "Ajdabiya",
    "Al Bayda",
    "Al Jabal al Akhdar",
    "Al Jufra",
    "Al Kufrah",
    "Al Marj",
    "Al Marqab",
    "Al Qubbah",
    "Al Qusayr",
    "An Nuqat al Khams",
    "Az Zawiyah",
    "Banghazi",
    "Darnah",
    "Ghadamis",
    "Gharyan",
    "Misratah",
    "Murzuq",
    "Nalut",
    "Sabha",
    "Surt",
    "Tarhunah",
    "Tobruk",
    "Yafran",
    "Zlitan",
];